import React from "react";
import { Form, Button, Row, Col, Alert } from "react-bootstrap";
import PropTypes from "prop-types";
import LocationsSrv from "../../services/locations_srv";


class LocationsForm extends React.Component {

    locationsSrv

    constructor(props) {
        super(props);

        this.state = {
            validated: false,
            newLocation: {
                name: "",
                type: "",            
            },
            error: ""
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleLocationNameChange = this.handleLocationNameChange.bind(this);
        this.handleLocationTypeChange = this.handleLocationTypeChange.bind(this);
        this.addNewLocation = this.addNewLocation.bind(this);
        this.handleCloseAlert = this.handleCloseAlert.bind(this);
        this.getAlert = this.getAlert.bind(this);

        this.locationsSrv = new LocationsSrv(this.props.auth);
    }

    handleSubmit(event) {
        event.preventDefault();
        event.stopPropagation();
        this.setState({ error: null });
        const form = event.currentTarget;
        if (form.checkValidity() === true) {
            this.setState({ validated: true });
            this.addNewLocation();
        }
        else {
            this.setState({ validated: false });
        }

    }

    handleCloseAlert() {
        this.setState({ error: null });
    }

    handleLocationNameChange(event) {
        var newLocation = { ...this.state.newLocation }
        newLocation.name = event.target.value;
        this.setState({ newLocation: newLocation });
    }

    handleLocationTypeChange(event) {
        let newLocation= { ...this.state.newLocation }
        newLocation.type = event.target.value;
        this.setState({ newLocation });      
    }

    addNewLocation() {
        var newLocation = { ...this.state.newLocation };        
        newLocation.name = newLocation.name.trim();
        this.locationsSrv.add(newLocation)
            .then((res) => {
                console.log(res.status)
                if (res.status === 201) {
                    this.props.newLocationAdded(newLocation);
                    newLocation.name = "";
                    this.setState({ newLocation: newLocation,validated: false  });
                }
                else {
                    console.log(res);
                    this.setState({ error: res.statusText });
                }
            },
                (error) => {
                    console.error(error);
                }
            )
            .catch(function (reason) {
                console.error(reason);
                this.setState({ error: reason });
            });
    }

    

    getAlert() {
        let error = this.state.error;
        let alert = <div></div>;
        if (error) {
            alert =
                <Alert
                    dismissible
                    onClose={this.handleCloseAlert}
                    variant="danger">
                    <Alert.Heading>Error</Alert.Heading>
                    <p>
                        {error.toString()}
                    </p>
                </Alert>;
        }
        return alert;
    }


    render() {
        const { validated, newLocation } = this.state;

        let alert = this.getAlert();

        return (
            <div>
                <Form
                    validated={validated}
                    onSubmit={this.handleSubmit}
                >
                    <Row>
                        <Col>
                            <Form.Control
                                name="name"
                                required
                                type="text"
                                value={newLocation.name}
                                placeholder="Location Name"
                                onChange={this.handleLocationNameChange} />
                        </Col>
                        <Col>
                        <Form.Control 
                            as="select" 
                            id="location-type-select" 
                            onChange={this.handleLocationTypeChange} 
                            required
                            value={newLocation.type}
                            title="Location Types">
                                <option disabled value="">-- Select --</option>
                                <option value="Manufacturer">Manufacturer</option>
                                <option value="Warehouse">Warehouse</option>
                                <option value="Customer">Customer</option>
                        </Form.Control>                        
                        </Col>
                        <Col>
                            <Button variant="primary" type="submit">
                                Add
                            </Button>
                        </Col>
                    </Row>
                </Form>
                {alert}
            </div>
        )

    }

}

LocationsForm.propTypes = {
    newLocationAdded: PropTypes.func,
    auth: PropTypes.object
};

export default LocationsForm;